<template>
  <div>
    <div class="z-text spacer-bottom-xs">
      <strong>Valor da mensalidade:</strong> {{ bill.bill_value | formatCurrency }}
    </div>

    <div class="z-text spacer-bottom-xs">
      <strong>Valor da multa:</strong> {{ bill.penalty | formatCurrency }}
    </div>

    <div class="z-text spacer-bottom-xs">
      <strong>Valor do juros:</strong> {{ bill.interest | formatCurrency }}
    </div>

    <div class="z-text spacer-bottom-l">
      <strong>Valor total para pagamento:</strong> {{ bill.full_value | formatCurrency }}
    </div>

    <router-link
      tag="button"
      :to="{ name: 'nb-payment-methods', params: { billId: bill.id } }"
      class="z-button z-button--primary z-button--block spacer-bottom-m"
    >
      Pagar
    </router-link>

    <router-link
      tag="button"
      :to="{ name: 'contacts' }"
      class="z-button z-button--secondary z-button--block"
    >
      Falar com o Quero Pago
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    bill: {
      type: Object,
      required: true,
    },
  },
};
</script>
